<template>
    <div>
        <ticketcats :categories="ticketCategories" :organisationtypes="organisationTypes"/>
    </div>
</template>
<script>
import Api from '@/services/Api.js'
import TicketCategories from '@/components/TicketCategories.vue'
export default {
    components: {
        ticketcats: TicketCategories
    },
    data(){
        return {
            ticketCategories: [],
            organisationTypes:[]
        }
    },
    created(){
        this.initialise()
    },
    methods: {
        initialise(){
            this.fetchTicketCategories()
            this.fetchOrgansationTypes()
        },
        fetchTicketCategories(){
            Api()
            .get('/ticketCategory')
            .then(response=>{
                this.ticketCategories = response.data
            })
        },
        fetchOrgansationTypes(){
            Api()
            .get('/organisationType')
            .then(response=>{
                this.organisationTypes = response.data
            })
        }
    }
}
</script>